import {
  FaTshirt,
  FaBirthdayCake,
  FaDumbbell,
  FaGem,
  FaUtensils,
  FaCouch,
  FaSpa,
  FaCut,
} from "react-icons/fa";

const AboutUs = () => {
  const categories = [
    { name: "Boutiques & Fashion", icon: <FaTshirt />, color: "#ff6b6b" },
    { name: "Home Bakers & Food", icon: <FaBirthdayCake />, color: "#ffa94d" },
    { name: "Fitness & Coaching", icon: <FaDumbbell />, color: "#4dabf7" },
    { name: "Jewellery", icon: <FaGem />, color: "#845ef7" },
    { name: "Restaurants & Cafes", icon: <FaUtensils />, color: "#f06595" },
    { name: "Home Decor & Art", icon: <FaCouch />, color: "#20c997" },
    { name: "Skincare & Wellness", icon: <FaSpa />, color: "#94d82d" },
    { name: "Salons & Spas", icon: <FaCut />, color: "#e64980" },
  ];
  return (
    <section id="about" className="section-padding text-center">
      <style type="text/stylesheet">
        {`.category-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  margin-top: 30px;
}

.category-item {
  text-align: center;
}

.category-item .icon {
  font-size: 28px;
  margin-bottom: 8px;
}`}
      </style>
      <div className="container mb-60">
        <h2>
          Why <span className="text-light">We Exist</span>
        </h2>

        <p className="lead" style={{ maxWidth: "800px", margin: "0 auto" }}>
          We saw so many talented business owners - bakers, salon owners,
          boutique founders - running everything through WhatsApp.
          <br />
          <br />
          Orders getting lost. Messages missed. No proper system.
          <br />
          <br />
          Not because they didn’t want to grow… but because building a website
          felt expensive, complicated, and out of reach.
          <br />
          <br />
          So we built Sarentu IT Solutions.
          <br />
          <br />
          We set up your complete Shopify store - from design to payments - so
          you can run your business smoothly, without stress or tech headaches.
          <br />
          <br />
          <strong>
            Your business deserves more than chats. It deserves a system.
          </strong>
        </p>
        <br />
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(4, 1fr)",
            gap: "20px",
            marginTop: "50px",
          }}
        >
          {categories.map((item, index) => (
            <div key={index} style={{ textAlign: "center" }}>
              <div
                style={{
                  backgroundColor: item.color + "20",
                  color: item.color,
                  width: "60px",
                  height: "60px",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "0 auto 10px",
                  fontSize: "24px",
                  transition: "0.3s",
                }}
              >
                {item.icon}
              </div>

              <p style={{ fontSize: "14px" }}>{item.name}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
